<ul
    *ngIf="{
        contact: contact$ | async,
        contactTypes: contactTypes$ | async,
        contactGroups: contactGroups$ | async,
        isTracking: isTracking$ | async,
        canEditContactGroup: canEditContactGroup$ | async,
        canEditContactType: canEditContactType$ | async,
    } as data">
    <li>
        <div class="nav-cont">
            <h6 class="title">Group</h6>
            <ng-select
                *ngIf="data.contact"
                class="slim"
                [disabled]="data.isTracking || !data.canEditContactGroup"
                [items]="data.contactGroups"
                placeholder="Contact Group"
                [clearable]="false"
                [searchable]="false"
                (change)="setGroup($event)"
                [(ngModel)]="data.contact.ContactGroup">
            </ng-select>
        </div>
    </li>
    <li>
        <div class="nav-cont">
            <h6 class="title">Type</h6>
            <ng-select
                *ngIf="data.contact"
                class="slim"
                [disabled]="data.isTracking || !data.canEditContactType"
                [items]="data.contactTypes"
                placeholder="Contact Type"
                [clearable]="false"
                [searchable]="false"
                (change)="setType($event)"
                [(ngModel)]="data.contact.ContactType">
            </ng-select>
        </div>
    </li>
</ul>
